import React from "react";
import { Checkbox, Column, Columns, Control, Field, Input, Title } from "@allxsmith/bestax-bulma";
import SaleCustomerDetails from "./SaleCustomerDetails";



export default function SaleInfo({financeAgreement, onChange, onCheck, endpoint}){
    const getProfit = () => {
        return (financeAgreement.sold_price - financeAgreement.estimated_value + ((financeAgreement.remaining_balance - financeAgreement.hp_remaining_interest) - financeAgreement.finance_early_settlement_amount_paid)) ? (financeAgreement.sold_price - financeAgreement.estimated_value + ((financeAgreement.remaining_balance - financeAgreement.hp_remaining_interest) - financeAgreement.finance_early_settlement_amount_paid)) : 0;
    };

    const getCashFlow = () => {
        return (financeAgreement.sold_price - financeAgreement.finance_early_settlement_amount_paid) ? (financeAgreement.sold_price - financeAgreement.finance_early_settlement_amount_paid) : 0;
    };
    return (
      <div>
        <Columns isMultiline>
        <Column>
          <Title size="4">Sale Info</Title>
        </Column>
      </Columns>
        <Columns isMultiline>
          <Column>
            <Field>
              <label className="label">Sale Date
                                </label>
              <Control>
                <Input
                  type="date"
                  name="internal_sale_date"
                  onChange={onChange}
                  value={financeAgreement.internal_sale_date || ""}/>
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Depreciated Value / Cost of Sale
                                </label>
              <Control>
                <Input
                  type="text"
                  value={
                    financeAgreement.finance_type !== 'GRANT_FINANCE' ?
                        (financeAgreement.estimated_value > 0
                      ? financeAgreement.estimated_value.toFixed(2)
                      : 0) : financeAgreement.estimated_grant_value
                  }
                  disabled
                  readOnly
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <label className="label">Invoice Number</label>
                <Input
                  type="text"
                  name="internal_invoice_number"
                  onChange={onChange}
                  value={financeAgreement.internal_invoice_number}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <label className="label">Advertised</label>
                <Checkbox
                  name="advertised"
                  onChange={(e) => onCheck(e.target.name)}
                  checked={financeAgreement.advertised}
                />
              </Control>
            </Field>
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <Field>
              <label className="label">Advertised Price</label>
              <Control>
                <Input
                  type="text"
                  name="external_list_price"
                  onChange={onChange}
                  value={financeAgreement.external_list_price}
                  required
                />
              </Control>
            </Field>
          </Column>

          <Column>
            <Field>
              <label className="label">Sold Price</label>
              <Control>
                <Input
                  type="text"
                  name="sold_price"
                  onChange={onChange}
                  value={financeAgreement.sold_price}
                  required
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Part Exchange</label>
              <Control className={"has-addons"}>
                <Input
                  name={"part_exchange"}
                  value={financeAgreement.part_exchange}
                  onChange={onChange}
                  type={"number"}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Sale Deposit</label>
              <Control>
                <Input
                  name={"sale_deposit"}
                  onChange={onChange}
                  type={"number"}
                  value={financeAgreement.sale_deposit}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Deposit Taken Date</label>
              <Control>
                <Input
                  name={"sale_deposit_date"}
                  onChange={onChange}
                  type={"date"}
                  value={financeAgreement.sale_deposit_date}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Profit</label>
              <Control>
                <Input
                  type="number"
                  name="profit"
                  value={getProfit().toFixed(2)}
                  disabled
                  readOnly
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Cash Flow</label>
              <Control>
                <Input
                  type="text"
                  name="sold_price"
                  onChange={onChange}
                  value={getCashFlow().toFixed(2)}
                  disabled
                  readOnly
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Sold Date
                                </label>
              <Control>
                <Input
                  type="date"
                  name="sold_date"
                  onChange={onChange}
                  value={financeAgreement.sold_date || ""}
                  disabled={true}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <label className="label">Comments</label>
                <Input
                  type="text"
                  name="sale_comments"
                  onChange={onChange}
                  value={financeAgreement.sale_comments}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <label className="label">Sold To</label>
                <Input
                  type="text"
                  name="sold_to"
                  onChange={onChange}
                  value={financeAgreement.sale_customer ? financeAgreement.sale_customer.display_name : ""}
                  disabled={true}
                />
              </Control>
            </Field>
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <SaleCustomerDetails finance={financeAgreement} onChange={onChange} endpoint={endpoint}/>
          </Column>
        </Columns>
      </div>
    );



}